module.exports = __webpack_public_path__ + "static/step3-c04bd19ff6d54837a1eb9308851747eb.png";